;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		const megaMenus = document.querySelectorAll('.mega-menu')

		const closeAllMegaMenus = () => {
			if (!megaMenus) return;
			megaMenus.forEach((megaMenu) => {
				megaMenu.style.opacity = 0;
				megaMenu.style.display = 'none';
			});
			menuLinks.forEach((el) => {
				el.classList.remove('list-menu--megamenu-visible');
			});
		};

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				clearTimeout(hideMenuTimeout);

				if (!link.classList.contains('list-menu--megamenu')) {
					closeAllMegaMenus();
					return;
				}

				link.classList.add('list-menu--megamenu-visible');
				if (!megaMenus) return;

				megaMenus.forEach((megaMenu) => {
					if (megaMenu !== link.querySelector('.mega-menu')) {
						return;
					}

					if (megaMenu.style.display !== 'grid') {
						megaMenu.style.opacity = 0;
						megaMenu.style.display = 'grid';
						setTimeout(() => {
							megaMenu.style.opacity = 1;
						}, 50);
					} else {
						megaMenu.style.opacity = 1;
					}

					/*
					const headerMain = header.querySelector('.header');
					const calcPosition = () => {
						megaMenu.style.right = 'auto';
						const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs');
						if (megaMenuTabs && megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
							megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`;
							megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`;
						}

						const megaMenuRight = megaMenu.getBoundingClientRect().right;
						const headerRight = headerMain.getBoundingClientRect().right;
						if (megaMenuRight > headerRight) {
							megaMenu.style.right = '2rem';
						}
					};

					calcPosition();
					let headerMainWidth = headerMain.offsetWidth;
					const resizeObserver = new ResizeObserver((entries) => {
						for (const entry of entries) {
							const newWidth = entry.contentRect.width;
							if (newWidth !== headerMainWidth) {
								headerMainWidth = newWidth;
								calcPosition();
							}
						}
					});
					resizeObserver.observe(headerMain);
					*/
				});

				// Hide other mega menus instantly to avoid overlap
				menuLinks.forEach((el) => {
					if (el === link) return;
					el.classList.remove('list-menu--megamenu-visible');
					const otherMegaMenu = el.querySelector('.mega-menu');
					if (otherMegaMenu) {
						otherMegaMenu.style.opacity = 0;
						otherMegaMenu.style.display = 'none';
					}
				});
			});

			link.addEventListener('mouseleave', (e) => {
				if (!link.classList.contains('list-menu--megamenu')) return;
				if (!megaMenus) return;

				clearTimeout(hideMenuTimeout);
				hideMenuTimeout = setTimeout(() => {
					const megaMenu = link.querySelector('.mega-menu');
					if (!megaMenu) return;

					megaMenu.style.opacity = 0;
					setTimeout(() => {
						if (hideMenuTimeout) {
							megaMenu.style.display = 'none';
							link.classList.remove('list-menu--megamenu-visible');
						}
					}, 1000);
				}, 1500);
			});

			link.addEventListener('focus', (e) => {
				if (!link.classList.contains('list-menu--megamenu')) {
					closeAllMegaMenus();
					return;
				}

				link.classList.add('list-menu--megamenu-visible');
				if (!megaMenus) return;

				megaMenus.forEach((megaMenu) => {
					const megaMenuPositionRight = megaMenu.getBoundingClientRect().right;
					const windowRight = window.innerWidth;
					if (megaMenuPositionRight > windowRight) {
						megaMenu.style.right = '0';
					}
				});

				menuLinks.forEach((el) => {
					if (el !== link) {
						el.classList.remove('list-menu--megamenu-visible');
					}
				});
			});
		});

		menu.addEventListener('mouseleave', (e) => {
			if (!megaMenus) return;
			clearTimeout(hideMenuTimeout);
			hideMenuTimeout = setTimeout(() => {
				closeAllMegaMenus();
			}, 500);
		});

		menu.addEventListener('focusout', (e) => {
			if (!megaMenus) return;
			clearTimeout(hideMenuTimeout);
			hideMenuTimeout = setTimeout(() => {
				closeAllMegaMenus();
			}, 500);
		});

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const setActiveMenuState = () => {
			const normalizePath = (path) => {
				if (!path) return ''
				const cleaned = path.split('#')[0].trim().replace(/\/+$/, '')
				return cleaned === '' ? '/' : cleaned.toLowerCase()
			}

			const currentPath = normalizePath(window.location.pathname)
			const currentSearch = (window.location.search || '').toLowerCase()
			const currentFullPath = currentPath + currentSearch

			// Clean any existing active states first
			document
				.querySelectorAll(
					'.list-menu-item--active, .header__menu-item--active, .menu-drawer__menu-item--active, .is-active'
				)
				.forEach((el) => {
					el.classList.remove(
						'list-menu-item--active',
						'header__menu-item--active',
						'menu-drawer__menu-item--active',
						'is-active'
					)
					if (el.hasAttribute('aria-current')) {
						el.removeAttribute('aria-current')
					}
				})

			// If on the Home page, no category/mega-menu should remain active
			if (currentPath === '/') return

			const desktopMenuItems = document.querySelectorAll(
				'.list-menu--inline > .list-menu-item'
			)

			desktopMenuItems.forEach((menuItem) => {
				const parentLink = menuItem.querySelector(':scope > .header__menu-item')
				if (!parentLink) return

				const isDropdown =
					menuItem.classList.contains('list-menu--megamenu') ||
					menuItem.classList.contains('list-menu--submenu')

				const targetLinks = isDropdown
					? menuItem.querySelectorAll('.mega-menu a[href], .header__submenu a[href]')
					: [parentLink]

				let isParentActive = false

				targetLinks.forEach((link) => {
					const rawHref = link.getAttribute('href')
					if (
						!rawHref ||
						rawHref === '#' ||
						rawHref === '/' ||
						rawHref.startsWith('#') ||
						rawHref.startsWith('javascript:')
					) {
						return
					}

					let linkPath = ''
					let linkSearch = ''

					try {
						const parsedUrl = new URL(link.href, window.location.origin)
						linkPath = normalizePath(parsedUrl.pathname)
						linkSearch = (parsedUrl.search || '').toLowerCase()
					} catch (err) {
						linkPath = normalizePath(rawHref.split('?')[0])
					}

					if (!linkPath || linkPath === '/') return

					const isExactMatch =
						linkSearch.length > 0
							? linkPath + linkSearch === currentFullPath
							: linkPath === currentPath

					if (!isExactMatch) return

					isParentActive = true
					link.classList.add('header__menu-item--active', 'is-active')
				})

				if (!isParentActive) return

				menuItem.classList.add('list-menu-item--active')
				parentLink.classList.add('header__menu-item--active')
				parentLink.setAttribute('aria-current', 'page')
			})

			const mobileMenuItems = document.querySelectorAll(
				'.menu-drawer__menu > li'
			)

			mobileMenuItems.forEach((menuItem) => {
				const summaryOrLink = menuItem.querySelector(
					':scope > details > summary, :scope > .menu-drawer__menu-item'
				)
				if (!summaryOrLink) return

				const isSubmenu = menuItem.querySelector('details') !== null
				const targetLinks = isSubmenu
					? menuItem.querySelectorAll(
							'.menu-drawer__submenu a[href], .menu-drawer__mega-menu a[href]'
					  )
					: [summaryOrLink]

				let isParentActive = false

				targetLinks.forEach((link) => {
					const rawHref = link.getAttribute('href')
					if (
						!rawHref ||
						rawHref === '#' ||
						rawHref === '/' ||
						rawHref.startsWith('#') ||
						rawHref.startsWith('javascript:')
					) {
						return
					}

					let linkPath = ''
					let linkSearch = ''

					try {
						const parsedUrl = new URL(link.href, window.location.origin)
						linkPath = normalizePath(parsedUrl.pathname)
						linkSearch = (parsedUrl.search || '').toLowerCase()
					} catch (err) {
						linkPath = normalizePath(rawHref.split('?')[0])
					}

					if (!linkPath || linkPath === '/') return

					const isExactMatch =
						linkSearch.length > 0
							? linkPath + linkSearch === currentFullPath
							: linkPath === currentPath

					if (!isExactMatch) return

					isParentActive = true
					link.classList.add('menu-drawer__menu-item--active', 'is-active')
				})

				if (!isParentActive) return

				summaryOrLink.classList.add('menu-drawer__menu-item--active')
			})
		}

		setActiveMenuState()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0] &&
			main
				.querySelectorAll('.shopify-section')[0]
				.classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		menuCloseBtn.addEventListener('click', (e) => {
			mobileMenuDrawer.closeMenuDrawer(e)
		})
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()
